import {GetEnumValueName} from "./EnumHelper";
import dayjs from "dayjs";

export const GetOrderTitle = (order) => {

    if (!order) {
        return 'Undefined';
    }

    return GetEnumValueName('orderAction', order.action) +
        ' from ' +
        dayjs(order.createdDate).toDate().toDateString();
}

export const GetBrokerageAgreementTitle = (agreement) => {
    if (agreement === undefined) {
        return 'undefined';
    }

    let title = dayjs(agreement.conclusionDate).toDate().toDateString();

    if (agreement.terminationDate !== null) {
        title += ' - ';
        title += dayjs(agreement.terminationDate).toDate().toDateString();
    }
    return title;
}